/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "common": {
            "nested": {
              "SchemeData": {
                "fields": {
                  "transactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "spendQualifierIndicator": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "schemeResponseCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantAdviceCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "fraudScore": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "fraudClassificationCode": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.common?.nested?.SchemeData) {
  $root.addJSON(jsonData);
}

/**
 * Scheme-specific raw data returned to the payment gateway in the response message. Can be
 * useful for matching disputes or computing interchange.
 *
 * SOURCE SchemeData @ squareup/esperanto/common/scheme.proto at 11:1
 */
export const SchemeData = $root.lookupType('squareup.esperanto.common.SchemeData');
fixType(SchemeData);
Builder.createAndAttachToType(SchemeData);